import { render, staticRenderFns } from "./Two.vue?vue&type=template&id=f7affa1e&lang=html"
import script from "./Two.vue?vue&type=script&lang=js"
export * from "./Two.vue?vue&type=script&lang=js"
import style0 from "./Two.vue?vue&type=style&index=0&id=f7affa1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports